import request from '@/utils/request'

export default {
  submitForm (data) {
    return request({
      url: 'auth/signUp',
      method: 'post',
      data
    })
  },
  checkIfSubmitted () {
    return request({
      url: 'auth/checkSignUp',
      method: 'post'
    })
  },
  memberSubmit () {
    return request({
      url: 'auth/signUpByOwlnest',
      method: 'post'
    })
  }
}
